export default __webpack_public_path__ + "static/media/85.21464090.jpg";